import { store } from './../../../store';
export const getChannelFromEpg = group_id => {
  const epgChannels = store.getState().Player.EpgChannels?.data;

  const channelFromEpg = epgChannels.find(
    channel => channel.group_id === group_id,
  );
  return channelFromEpg;
};
